import React from "react";
import {UserWithStats} from "../UserWithStats";
import {TFunction} from "i18next";

export abstract class StatsStrategy {
    abstract leftPart(t: TFunction<"translation", undefined>, playerStats: UserWithStats): React.ReactNode
    abstract rightPart(t: TFunction<"translation", undefined>, playerStats: UserWithStats): React.ReactNode
}
